import React, {
  createContext,
  useContext,
  useEffect,
  useLayoutEffect,
} from "react";

import "./App.scss";
import { getStorageItem } from "./utils/localStorage";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import loginWallPaper from "./assets/img/login-img.svg";
import errorWallpaper from "./assets/img/error.jpg";

import { Suspense } from "react";
import Loader from "./components/Loader/Loader";
import MobilePage from "./components/MobilePage/MobilePage";
import Login from "./pages/Login/Login";

import Home from "./pages/Home/Home";
import Companies from "./pages/Companies/Companies";
import Auth from "./components/Auth/Auth";
import { CreateCompany } from "./pages/Companies/CreateCompanies/CreateCompanies";
import { RoutesRouter } from "./models/Routes";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import { useInterceptor } from "./hooks/useInterceptor";
import { Toast, ProviderToastAlert } from "./components/ToastAlert/ToastAlert";
import { Template } from "./pages/Survey/Template/Template";
import { QuestionsPage } from "./pages/Survey/Demands/Questions/QuestionsPage";
import { CreateQuestions } from "./pages/Survey/Demands/Questions/CreateQuestions";
import { TemplatePage } from "./pages/Survey/Template/TemplatePage";
import { CreateTemplate } from "./pages/Survey/Template/CreateTemplate";
import FormStep from "./components/Forms/FormCreateTemplate/FormStep";
import LibraryPage from "./pages/Library/LibraryPage";
import CreateLibrary from "./pages/Library/CreateLibrary/CreateLibrary";
import { CreateIssue } from "./pages/Issue/CreateIssue/CreateIssue";
import IssuePage from "./pages/Issue/IssuePage";
import 'react-loading-skeleton/dist/skeleton.css';

interface IApp {
  children?: React.ReactNode;
}
function App() {
  const { jwtInterceptor } = useInterceptor();
  const navigate = useNavigate();

  const RedirectRootPath = ({ children }: IApp) => {
    const me = getStorageItem("me");
    const token = getStorageItem("token");
    if (!me || !token) return <Navigate to={RoutesRouter.login} />;
    return <>{children}</>;
  };

  useLayoutEffect(() => {
    jwtInterceptor(navigate);
  }, [jwtInterceptor, navigate]);

  return (
    <Suspense fallback={<Loader />}>
      <MobilePage>
        <ProviderToastAlert>
          <Routes>
            <Route path="" element={<Navigate to={RoutesRouter.companies} />} />
            <Route
              path="/home"
              element={<Navigate to={RoutesRouter.companies} />}
            ></Route>
            <Route
              path="/home"
              element={
                <RedirectRootPath>
                  <Home />
                </RedirectRootPath>
              }
            >
              <Route path="companies" element={<Companies />}></Route>
              <Route path="companies/create" element={<CreateCompany />} />
              <Route path="companies/:id/edit" element={<CreateCompany />} />
              <Route
                path="survey"
                element={<Navigate to={RoutesRouter.template} />}
              />
              <Route path="survey/template" element={<TemplatePage />} />
              <Route
                path="survey/template/:id/edit"
                element={<CreateTemplate />}
              />
              <Route
                path="survey/template/create"
                element={<CreateTemplate />}
              />

              <Route path="survey/questions" element={<QuestionsPage />} />
              <Route
                path="survey/questions/:id/edit"
                element={<CreateQuestions />}
              />
              <Route
                path="survey/questions/create"
                element={<CreateQuestions />}
              />
              <Route path="library" element={<LibraryPage />} />
              <Route path="library/create" element={<CreateLibrary />} />
              <Route path="library/:id/edit" element={<CreateLibrary />} />
              <Route path="issue" element={<IssuePage />} />
              <Route path="issue/create" element={<CreateIssue />} />
              <Route path="issue/:id/edit" element={<CreateIssue />} />
            </Route>
            <Route
              path="/login"
              element={<Auth wallpaper={loginWallPaper} children={<Login />} />}
            />
            <Route
              path="/page-not-found"
              element={
                <Auth wallpaper={errorWallpaper} children={<PageNotFound />} />
              }
            />
            <Route
              path="*"
              element={
                <Auth wallpaper={errorWallpaper} children={<PageNotFound />} />
              }
            />
          </Routes>
          <Toast />
        </ProviderToastAlert>
      </MobilePage>
    </Suspense>
  );
}

export default App;
